import { Reveal, Overline } from "./Reveal";

const STEPS = [
  {
    month: "Week 0",
    n: "01",
    title: "Onboarding call",
    body: "45 minutes, one-to-one. We map your six months and set your checkpoint dates.",
  },
  {
    month: "Month 1",
    n: "02",
    title: "Entity & Seller Central",
    body: "Entity, EIN, and your Seller Central application — reviewed live at checkpoint one.",
  },
  {
    month: "Month 2",
    n: "03",
    title: "Product validation",
    body: "Research criteria applied with you, live. Checkpoint two locks your product.",
  },
  {
    month: "Month 3",
    n: "04",
    title: "Supplier outreach",
    body: "Brand and supplier scripts, sent together. Checkpoint three reviews responses.",
  },
  {
    month: "Month 4",
    n: "05",
    title: "First purchase order",
    body: "Checkpoint four: your first PO, pricing, and order flow — placed with the team.",
  },
  {
    month: "Months 5–6",
    n: "06",
    title: "Launch & account health",
    body: "Listings live, orders flowing, account health managed — pushing toward $10,000 in gross sales.",
  },
];

export function Timeline() {
  return (
    <section data-testid="timeline-section" className="border-t border-black/10">
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-48">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Overline>The six-month map</Overline>
            <h2 className="mt-6 max-w-3xl font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-6xl">
              Every week is planned{" "}
              <span className="text-ink/40">before you start.</span>
            </h2>
          </div>
          <p className="max-w-sm font-body text-sm text-ink/50">
            Four one-to-one checkpoints sit on the four stages that decide
            whether a store launches or stalls.
          </p>
        </Reveal>

        <div className="mt-20 grid gap-px bg-black/10 md:grid-cols-2 lg:grid-cols-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08} className="bg-white">
              <article
                data-testid={`timeline-step-${i}`}
                className="group relative flex h-full flex-col p-8 transition-colors duration-300 hover:bg-[#F4F2EC]"
              >
                <div className="flex items-center gap-3">
                  <span className="h-2.5 w-2.5 rounded-full bg-signal transition-transform duration-300 group-hover:scale-125" />
                  <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/50">
                    {s.month}
                  </span>
                </div>
                <span className="mt-8 font-display text-6xl font-black tracking-tighter text-stroke">
                  {s.n}
                </span>
                <h3 className="mt-6 font-display text-xl font-bold tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-ink/60">
                  {s.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
